import { useCallback } from 'react'
import { unstakeFarm } from 'utils/calls'
import { refreshFarmUserDataFromPid } from 'state/farms/useDeserializedFarmsUser'
import { useCraftsman } from 'hooks/useContract'
import { DEFAULT_GAS_LIMIT } from 'config'

const useUnstakeFarms = (pid: number) => {
  const craftsmanContract = useCraftsman()

  const handleUnstake = useCallback(
    async (amount: string) => {
      await unstakeFarm(craftsmanContract, pid, amount, DEFAULT_GAS_LIMIT)
      refreshFarmUserDataFromPid(pid, 1)
    },
    [craftsmanContract, pid],
  )

  return { onUnstake: handleUnstake }
}

export default useUnstakeFarms
